import React, { useEffect, useRef, useState } from 'react';
import { useRecordContext } from 'react-admin';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export const hasMortgageFreeHousing = (record) =>
  record?.gastosVivienda?.tipoVivienda === 'propiedadSinHipoteca';

/**
 * Warn staff whenever they open a client's record whose home is mortgage-free.
 * `record` is optional so this can be used inside a react-admin form as well as
 * on the custom details page, which loads its record directly from Firestore.
 */
const MortgageFreeNotice = ({ record: suppliedRecord }) => {
  const contextRecord = useRecordContext();
  const record = suppliedRecord || contextRecord;
  const shownRecordId = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!record?.id || shownRecordId.current === record.id) return;

    shownRecordId.current = record.id;
    if (hasMortgageFreeHousing(record)) setOpen(true);
  }, [record]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="mortgage-free-notice-title"
      aria-describedby="mortgage-free-notice-description"
    >
      <DialogTitle id="mortgage-free-notice-title">
        Aviso: propiedad sin hipoteca
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="mortgage-free-notice-description">
          El cliente ha indicado que su vivienda es una propiedad sin hipoteca.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="contained" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MortgageFreeNotice;
